var _polygon, _path, _polygon2, _polygon3, _path2, _polygon4, _path3, _polygon5, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _path14, _path15, _polygon20, _path16, _path17, _path18, _path19, _path20, _polygon21, _polygon22, _path21, _polygon23, _polygon24, _path22, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _path23, _polygon36, _path24, _polygon37, _path25, _polygon38, _polygon39, _path26, _polygon40, _path27, _path28, _path29, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthclaims(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 66 66",
    viewBox: "0 0 66 66",
    width: 70,
    height: 70,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#7e8a8c",
    points: "2.6 41.3 5.3 42.9 5.2 29.7 2.6 28.1",
    className: "color7e8a8c svgShape"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a0a8aa",
    d: "M3.2 18.2c-.4.2-.7.7-.7 1.2l0 8.7 2.7 1.6 0-8.7c0-.4.3-1 .7-1.2l4.6-2.6-2.7-1.6L3.2 18.2zM2.7 62.9c0 .2.1.4.2.4L5.6 65c-.1-.1-.2-.2-.2-.4l0-8.4-2.7-1.6L2.7 62.9z",
    className: "colora0a8aa svgShape"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#a0a8aa",
    points: "2.7 54.5 5.3 56.1 5.3 42.9 2.6 41.3",
    className: "colora0a8aa svgShape"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#7e8a8c",
    points: "7.8 15.6 10.5 17.2 20.4 11.5 17.7 9.9",
    className: "color7e8a8c svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0a8aa",
    d: "M36,2.6L33.4,1c-0.1-0.1-0.3-0.1-0.5,0l-4.6,2.6L31,5.3l4.6-2.6C35.7,2.6,35.9,2.6,36,2.6z",
    className: "colora0a8aa svgShape"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8d9799",
    points: "17.7 9.9 20.4 11.5 31 5.3 28.3 3.7",
    className: "color8d9799 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6d797a",
    d: "M35.6,2.7c0.4-0.2,0.7,0,0.7,0.4l0.1,43.5c0,0.4-0.3,1-0.7,1.2L6,64.9c-0.4,0.2-0.7,0-0.7-0.4 L5.2,21c0-0.4,0.3-1,0.7-1.2L35.6,2.7z",
    className: "color6d797a svgShape"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "7.7 21.6 33.8 6.6 33.9 46 7.8 61",
    className: "colorfff svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd651",
    d: "M28.6,6.8c-0.3-0.2-0.8-0.2-1.3,0.1l-2.9,1.7L23.3,8l2.9-1.7c0.5-0.3,1-0.3,1.3-0.1L28.6,6.8z",
    className: "colorffd651 svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ddb040",
    d: "M28.6 6.8c-.3-.2-.8-.2-1.3.1l-1.1-.6c.5-.3 1-.3 1.3-.1L28.6 6.8zM22.3 7.8c0 .5-.3 1-.7 1.3-.2.1-.4.1-.5.1l-.5-.3c.1.1.3.1.5-.1.4-.2.7-.8.7-1.3 0-.2-.1-.4-.2-.5l.5.3C22.3 7.4 22.3 7.5 22.3 7.8z",
    className: "colorddb040 svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd651",
    d: "M23.5,6.1c-0.5-0.3-1.2-0.2-1.9,0.2c-1.5,0.9-2.7,3-2.7,4.7l0,0.8l-1.1-0.6l0-0.8 c0-1.7,1.2-3.8,2.7-4.7c0.7-0.4,1.4-0.5,1.9-0.2L23.5,6.1z",
    className: "colorffd651 svgShape"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ddb040",
    d: "M18.9,11l0,0.8l-1.1-0.6v-0.8c0-1.7,1.2-3.8,2.7-4.7l1.1,0.6C20.1,7.2,18.9,9.3,18.9,11z",
    className: "colorddb040 svgShape"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#efc348",
    d: "M27.3,6.9c1-0.6,1.9-0.1,1.9,1.1l0,3.2l-15,8.6l0-3.2c0-1.2,0.8-2.6,1.8-3.2l2.9-1.7l0-0.8 c0-1.7,1.2-3.8,2.7-4.7c0.7-0.4,1.4-0.5,1.9-0.2C24,6.4,24.3,7,24.3,7.9l0,0.8L27.3,6.9z M21.6,9 c0.4-0.2,0.7-0.8,0.7-1.3c0-0.5-0.3-0.7-0.7-0.4c-0.4,0.2-0.7,0.8-0.7,1.3C20.9,9.1,21.2,9.3,21.6,9L21.6,9z",
    className: "colorefc348 svgShape"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd651",
    d: "M18.9,11.8L16,13.4c-1,0.6-1.9,2-1.8,3.2l0,3.2l-1.1-0.6l0-3.2c0-1.2,0.8-2.6,1.8-3.2l2.9-1.7 L18.9,11.8z",
    className: "colorffd651 svgShape"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ddb040",
    d: "M14.1 16.6l0 3.2-1.1-.6 0-3.2c0-1.2.8-2.6 1.8-3.2l1.1.6C15 14 14.1 15.5 14.1 16.6zM17 14.8c.1.1.1.3.1.5 0 .6-.5 1.4-1 1.8-.1 0-.1 0-.2.1.2.3.5.3.9.1.6-.3 1-1.1 1-1.8C17.8 14.9 17.4 14.7 17 14.8z",
    className: "colorddb040 svgShape"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#6d797a",
    d: "M17.1,15.3c0-0.2-0.1-0.3-0.1-0.5c-0.1,0-0.1,0-0.2,0.1c-0.6,0.3-1,1.1-1,1.8c0,0.2,0.1,0.3,0.1,0.5 c0.1,0,0.1,0,0.2-0.1C16.6,16.7,17.1,15.9,17.1,15.3z",
    className: "color6d797a svgShape"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ddb040",
    d: "M27.5,8.7c0.1,0.1,0.1,0.3,0.1,0.5c0,0.6-0.5,1.4-1,1.8c-0.1,0-0.1,0-0.2,0.1c0.2,0.3,0.5,0.3,0.9,0.1 c0.6-0.3,1-1.1,1-1.8C28.3,8.8,28,8.6,27.5,8.7z",
    className: "colorddb040 svgShape"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#6d797a",
    d: "M27.7,9.2c0-0.2-0.1-0.3-0.1-0.5c-0.1,0-0.1,0-0.2,0.1c-0.6,0.3-1,1.1-1,1.8c0,0.2,0.1,0.3,0.1,0.5 c0.1,0,0.1,0,0.2-0.1C27.2,10.6,27.7,9.8,27.7,9.2z",
    className: "color6d797a svgShape"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#00649b",
    points: "33.3 25.9 32.1 25.2 32.1 18.5 33.3 19.2",
    className: "color00649b svgShape"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#3f9ae0",
    points: "33.3 19.2 32.1 18.5 62.2 1 63.4 1.7",
    className: "color3f9ae0 svgShape"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#00649b",
    points: "33.3 19.2 32.1 18.5 54.8 5.2 56.1 6",
    className: "color00649b svgShape"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#3f9ae0",
    points: "33.3 19.2 32.1 18.5 44.6 11.1 45.9 11.8",
    className: "color3f9ae0 svgShape"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0074d1",
    points: "63.4 1.7 63.5 8.5 33.3 25.9 33.3 19.2",
    className: "color0074d1 svgShape"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "35.4 23.2 35 23 35 19.6 35.4 19.8",
    className: "colorb2b0af svgShape"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "35.4 19.8 35 19.6 35.7 19.2 36.1 19.4",
    className: "colorb2b0af svgShape"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "36.1 19.4 36.1 22.8 35.4 23.2 35.4 19.8",
    className: "colorfff svgShape"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "38.9 19.9 38.5 19.7 38.5 17.6 38.9 17.8",
    className: "colorb2b0af svgShape"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "38.9 17.8 38.5 17.6 39.2 17.2 39.6 17.4",
    className: "colorb2b0af svgShape"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "39 21.2 38.6 21 37.1 19.7 37.5 19.9",
    className: "colorb2b0af svgShape"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "36.8 19 36.4 18.8 37 18.4 37.4 18.6",
    className: "colorb2b0af svgShape"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "36.8 22.4 36.5 22.2 36.4 18.8 36.8 19",
    className: "colorb2b0af svgShape"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "39.6 17.4 39.6 20.8 39 21.2 37.5 19.9 37.5 22 36.8 22.4 36.8 19 37.4 18.6 38.9 19.9 38.9 17.8",
    className: "colorfff svgShape"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2b0af",
    d: "M41.4 18.2l.4.2c0 0 .1.1.1.2 0 .1 0 .2-.1.4l-.4-.2c.1-.1.1-.2.1-.4C41.5 18.3 41.4 18.2 41.4 18.2zM42 17.4l.4.2c-.1-.1-.2-.1-.3-.1l-.4-.2C41.8 17.4 41.9 17.4 42 17.4z",
    className: "colorb2b0af svgShape"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2b0af",
    d: "M40.3,19.5l-0.4-0.2c0.1,0,0.3,0,0.5,0c0.2,0,0.4-0.1,0.5-0.2c0.2-0.1,0.3-0.2,0.4-0.4l0.4,0.2 c-0.1,0.1-0.2,0.2-0.4,0.4c-0.2,0.1-0.4,0.2-0.5,0.2C40.6,19.5,40.4,19.5,40.3,19.5z",
    className: "colorb2b0af svgShape"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "40 20.2 39.7 20 39.9 19.3 40.3 19.5",
    className: "colorb2b0af svgShape"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2b0af",
    d: "M41.9 16.1l-.4-.2c.2-.1.3-.1.5 0l.4.2C42.3 16 42.1 16 41.9 16.1zM40.9 17.8l-.4-.2c0 0 .1 0 .1 0 .1 0 .3 0 .5-.1.2-.1.4-.1.6-.1l.4.2c-.1 0-.3.1-.6.1C41.2 17.8 41.1 17.8 40.9 17.8 40.9 17.8 40.9 17.8 40.9 17.8zM40.3 18.6l-.4-.2c0 0 0 0-.1 0L40.3 18.6C40.3 18.6 40.3 18.6 40.3 18.6z",
    className: "colorb2b0af svgShape"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2b0af",
    d: "M41.4,16.3L41,16.1c0.2-0.1,0.4-0.2,0.6-0.2l0.4,0.2C41.7,16.1,41.5,16.2,41.4,16.3z",
    className: "colorb2b0af svgShape"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2b0af",
    d: "M40.7,16.8l-0.4-0.2c0.2-0.2,0.4-0.4,0.7-0.5l0.4,0.2C41.1,16.5,40.8,16.6,40.7,16.8z",
    className: "colorb2b0af svgShape"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M41.4,16.3c0.2-0.1,0.4-0.2,0.6-0.2c0.2-0.1,0.3-0.1,0.5,0l-0.2,0.7c-0.3,0-0.6,0-0.8,0.2 c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.3,0,0.5-0.1c0.2-0.1,0.4-0.1,0.6-0.1 c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.2,0.2,0.5c0,0.2,0,0.4-0.1,0.6c-0.1,0.2-0.2,0.4-0.4,0.6c-0.2,0.2-0.4,0.4-0.7,0.5 c-0.2,0.1-0.5,0.2-0.7,0.3c-0.2,0.1-0.4,0.1-0.5,0l0.2-0.7c0.1,0,0.3,0,0.5,0c0.2,0,0.4-0.1,0.5-0.2c0.2-0.1,0.3-0.2,0.4-0.4 c0.1-0.1,0.1-0.2,0.1-0.4c0-0.1,0-0.1-0.1-0.2c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.4,0.1c-0.2,0.1-0.4,0.1-0.6,0.1 c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.2-0.2-0.5c0-0.2,0-0.4,0.1-0.6c0.1-0.2,0.2-0.4,0.4-0.6C40.8,16.6,41.1,16.5,41.4,16.3z",
    className: "colorfff svgShape"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2b0af",
    d: "M40.3 18.6l-.4-.2c-.1-.1-.2-.2-.2-.5 0-.2 0-.4.1-.6.1-.2.2-.4.4-.6l.4.2c-.2.2-.3.4-.4.6-.1.2-.1.4-.1.6C40.1 18.3 40.2 18.5 40.3 18.6zM43.9 17.5l-.4-.2c.1.1.3 0 .5-.1.2-.1.4-.3.5-.5.1-.2.2-.5.2-.8l.4.2c0 .3-.1.6-.2.8-.1.2-.3.4-.5.5C44.1 17.6 44 17.6 43.9 17.5z",
    className: "colorb2b0af svgShape"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "45 16.2 44.6 15.9 44.6 14 45 14.3",
    className: "colorb2b0af svgShape"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "45 14.3 44.6 14 45.3 13.6 45.7 13.9",
    className: "colorb2b0af svgShape"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2b0af",
    d: "M43.3,18.3L43,18.1c-0.2-0.1-0.4-0.5-0.4-1l0.4,0.2C43,17.9,43.1,18.2,43.3,18.3z",
    className: "colorb2b0af svgShape"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "43 15.4 42.6 15.2 43.3 14.8 43.7 15",
    className: "colorb2b0af svgShape"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "43 17.4 42.6 17.1 42.6 15.2 43 15.4",
    className: "colorb2b0af svgShape"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M45.7,13.9l0,1.9c0,0.5-0.1,1-0.4,1.4c-0.2,0.4-0.6,0.7-1,1c-0.4,0.2-0.8,0.3-1,0.2 c-0.2-0.1-0.4-0.5-0.4-1l0-1.9l0.7-0.4l0,1.9c0,0.6,0.2,0.8,0.7,0.5c0.2-0.1,0.4-0.3,0.5-0.5c0.1-0.2,0.2-0.5,0.2-0.8l0-1.9 L45.7,13.9z",
    className: "colorfff svgShape"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "54.9 10.7 54.5 10.4 54.5 8.3 54.9 8.6",
    className: "colorb2b0af svgShape"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "54.9 8.6 54.5 8.3 55.2 7.9 55.5 8.2",
    className: "colorb2b0af svgShape"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "55 11.9 54.6 11.7 53.1 10.5 53.5 10.7",
    className: "colorb2b0af svgShape"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "52.8 9.8 52.4 9.5 53 9.2 53.4 9.4",
    className: "colorb2b0af svgShape"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "52.8 13.2 52.4 13 52.4 9.5 52.8 9.8",
    className: "colorb2b0af svgShape"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "55.5 8.2 55.6 11.6 55 11.9 53.5 10.7 53.5 12.8 52.8 13.2 52.8 9.8 53.4 9.4 54.9 10.7 54.9 8.6",
    className: "colorfff svgShape"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "51.8 13.8 51.4 13.6 51.1 13 51.5 13.2",
    className: "colorb2b0af svgShape"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "50.3 13.3 50 13.1 50.9 12.5 51.3 12.7",
    className: "colorb2b0af svgShape"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "51.3 12.7 50.9 12.5 50.4 11.5 50.8 11.7",
    className: "colorb2b0af svgShape"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "50.5 11.1 50.1 10.9 50.8 10.5 51.1 10.7",
    className: "colorb2b0af svgShape"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "49.1 15.3 48.8 15.1 50.1 10.9 50.5 11.1",
    className: "colorb2b0af svgShape"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M51.1,10.7l1.3,2.7l-0.7,0.4l-0.3-0.6L50.1,14l-0.3,0.9l-0.7,0.4l1.3-4.2L51.1,10.7z M50.3,13.3l1-0.6 l-0.5-1L50.3,13.3",
    className: "colorfff svgShape"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "48.3 15.8 47.9 15.6 47.3 15 47.7 15.2",
    className: "colorb2b0af svgShape"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2b0af",
    d: "M47.6 14.6l-.4-.2c.2-.1.4-.3.5-.4l.4.2C48 14.3 47.8 14.5 47.6 14.6zM47.8 13.1l.4.2c.1 0 .1.2.1.3 0 .2-.1.4-.2.5l-.4-.2c.1-.2.2-.3.2-.5C47.9 13.2 47.9 13.1 47.8 13.1z",
    className: "colorb2b0af svgShape"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "47.1 14.9 46.7 14.7 47.3 14.4 47.6 14.6",
    className: "colorb2b0af svgShape"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2b0af",
    d: "M48.3,12.3l0.4,0.2c-0.1-0.1-0.2-0.1-0.3-0.1c-0.2,0-0.4,0.1-0.7,0.2l-0.4-0.2c0.3-0.2,0.5-0.2,0.7-0.2 C48.1,12.2,48.2,12.3,48.3,12.3z",
    className: "colorb2b0af svgShape"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "46.4 13.5 46 13.2 47.3 12.5 47.7 12.7",
    className: "colorb2b0af svgShape"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "46.4 16.9 46 16.7 46 13.2 46.4 13.5",
    className: "colorb2b0af svgShape"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M48.4,14.7l0.7,0.7l-0.7,0.4l-0.6-0.6l0,0l-0.6,0.3l0,1l-0.7,0.4l0-3.4l1.3-0.7c0.3-0.2,0.5-0.2,0.7-0.2 c0.2,0,0.3,0,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.6c0,0.3-0.1,0.5-0.2,0.8C48.7,14.2,48.6,14.4,48.4,14.7z M48.1,14.2 c0.1-0.2,0.2-0.3,0.2-0.5s-0.1-0.3-0.2-0.3c-0.1,0-0.3,0-0.5,0.1l-0.6,0.3l0,1.2l0.6-0.3C47.8,14.5,48,14.3,48.1,14.2",
    className: "colorfff svgShape"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "58.5 8.9 58.1 8.7 58.6 8.9 58.9 9.1",
    className: "colorb2b0af svgShape"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2b0af",
    d: "M58.1 7.2l.4.2c0 0 0 0 .1 0L58.1 7.2C58.1 7.3 58.1 7.3 58.1 7.2zM57 9.8l-.4-.2c.1 0 .1.1.2.1.1 0 .3 0 .5-.1.3-.2.5-.5.7-.8l.4.2c-.2.4-.5.7-.7.8-.2.1-.4.2-.5.1C57.2 9.9 57.1 9.9 57 9.8zM58.5 6.5l.4.2c-.1-.1-.3-.1-.4-.1-.2 0-.4.1-.7.3l-.4-.2c.3-.2.5-.2.7-.3C58.2 6.4 58.3 6.4 58.5 6.5z",
    className: "colorb2b0af svgShape"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2b0af",
    d: "M56.5,10.6l-0.4-0.2c-0.1,0-0.2-0.1-0.2-0.2c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.3,0.1-0.7,0.2-1 c0.1-0.4,0.3-0.7,0.6-1c0.2-0.3,0.5-0.5,0.8-0.7l0.4,0.2c-0.3,0.2-0.6,0.4-0.8,0.7c-0.2,0.3-0.4,0.6-0.6,1 c-0.1,0.4-0.2,0.7-0.2,1c0,0.3,0.1,0.6,0.2,0.8C56.3,10.5,56.4,10.5,56.5,10.6z",
    className: "colorb2b0af svgShape"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M57.7,6.9c0.3-0.2,0.5-0.2,0.7-0.3c0.2,0,0.4,0,0.5,0.1l-0.4,0.7c-0.2-0.1-0.5-0.1-0.8,0 c-0.2,0.1-0.4,0.3-0.5,0.4c-0.1,0.2-0.3,0.4-0.3,0.6c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.2,0,0.4,0.1,0.5c0.1,0.1,0.2,0.2,0.3,0.2 c0.1,0,0.3,0,0.5-0.1c0.3-0.2,0.5-0.5,0.7-0.8l0.4,0.2c-0.1,0.3-0.3,0.5-0.5,0.8c-0.2,0.2-0.4,0.4-0.7,0.6 c-0.3,0.2-0.6,0.3-0.8,0.3c-0.2,0-0.4-0.1-0.6-0.3c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.3,0.1-0.7,0.2-1c0.1-0.4,0.3-0.7,0.6-1 C57.1,7.3,57.4,7,57.7,6.9z",
    className: "colorfff svgShape"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "60.1 8.4 59.7 8.1 61.3 7.2 61.7 7.4",
    className: "colorb2b0af svgShape"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "60.1 6.9 59.7 6.7 61.1 5.9 61.5 6.1",
    className: "colorb2b0af svgShape"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "59.4 9.4 59 9.2 59 5.7 59.4 5.9",
    className: "colorb2b0af svgShape"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2b0af",
    points: "59.4 5.9 59 5.7 61.3 4.4 61.7 4.6",
    className: "colorb2b0af svgShape"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "61.7 4.6 61.7 5.3 60.1 6.2 60.1 6.9 61.5 6.1 61.5 6.8 60.1 7.6 60.1 8.4 61.7 7.4 61.7 8.1 59.4 9.4 59.4 5.9",
    className: "colorfff svgShape"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#d6d4d2",
    points: "31.2 20.6 14.5 30.2 14.5 32.5 31.2 22.9",
    className: "colord6d4d2 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d6d4d2",
    points: "31.2 27.4 14.5 37 14.5 39.3 31.2 29.7",
    className: "colord6d4d2 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d6d4d2",
    points: "31.2 34.2 14.5 43.8 14.5 46.1 31.2 36.5",
    className: "colord6d4d2 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d6d4d2",
    points: "31.2 41 14.5 50.6 14.5 52.9 31.2 43.3",
    className: "colord6d4d2 svgShape"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f25a5a",
    d: "M42.4,29.9l-2.9-1.7c3.3,2,7.8-0.2,11.2-2.2c0.4-0.2,0.7-0.4,1.1-0.6l2.9,1.7c-0.3,0.2-0.7,0.4-1.1,0.6 C50.2,29.7,45.8,31.9,42.4,29.9z",
    className: "colorf25a5a svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc4848",
    d: "M48.3,27.3c-2.9,1.4-6,2.4-8.6,1l2.7,1.6c2.6,1.6,5.8,0.6,8.8-0.9L48.3,27.3z",
    className: "colorcc4848 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c44141",
    d: "M30.2,41.2l-2.9-1.7c-0.2,3.5,0,6.6,0.3,9.2l2.9,1.7C30.1,47.8,30,44.8,30.2,41.2z",
    className: "colorc44141 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc4848",
    d: "M30.5,50.4l-2.9-1.7c0.8,5.1,2.6,8.5,5.4,10.1l2.9,1.7C33.1,58.9,31.3,55.5,30.5,50.4z",
    className: "colorcc4848 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f25a5a",
    d: "M42.4,29.9l-2.9-1.7c-2.1,3.8-4.7,6.3-7.2,8.1l2.9,1.7C37.7,36.2,40.3,33.7,42.4,29.9z",
    className: "colorf25a5a svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc4848",
    d: "M32.3,36.4c-1.4,1-2.7,1.9-4,2.6c-0.4,0.2-0.7,0.4-1.1,0.6l2.9,1.7c0.3-0.2,0.7-0.4,1.1-0.6 c1.2-0.7,2.6-1.5,4-2.6L32.3,36.4z",
    className: "colorcc4848 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd4a4a",
    d: "M42.4,29.9c3.3,2,7.8-0.2,11.2-2.2c0.4-0.2,0.7-0.4,1.1-0.6c0.8,14-3.5,25.5-12.2,34.5 c-8.7,1.1-13-5.5-12.3-20.4c0.3-0.2,0.7-0.4,1.1-0.6C34.7,38.6,39.1,35.7,42.4,29.9z",
    className: "colordd4a4a svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M40.8,60.4c-2.4,0-4.3-0.7-5.8-2.3c-2.7-2.8-3.9-8.2-3.6-16.2l0.5-0.3c3.7-2.1,7.8-5,11-10.2 c0.8,0.3,1.6,0.4,2.5,0.4c2.7,0,5.5-1.3,8.1-2.7c0.2,12.3-3.7,22.8-11.6,31.1C41.5,60.4,41.1,60.4,40.8,60.4z",
    className: "colorfff svgShape"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#dd4a4a",
    points: "46.9 48.3 43.5 47.7 43.8 52.2 41.4 53.6 41.7 48.7 38.3 53.3 37.1 51.6 40.7 47.4 37.1 47.5 38.3 44.4 41.6 45 41.4 40.5 43.8 39.1 43.6 43.9 46.9 39.4 48.1 41.1 44.5 45.2 48.1 45.2",
    className: "colordd4a4a svgShape"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f25a5a",
    d: "M10.9,30.5c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2C8.9,32.7,9.8,31.1,10.9,30.5z",
    className: "colorf25a5a svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "12.2 31.4 10.5 34.4 9.6 33.9 9.9 33.5 10.4 33.8 11.9 31.2",
    className: "colorfff svgShape"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0074d1",
    d: "M10.9,37.2c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2C8.9,39.5,9.8,37.9,10.9,37.2z",
    className: "color0074d1 svgShape"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffd651",
    d: "M10.9,44c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2C8.9,46.2,9.8,44.6,10.9,44z",
    className: "colorffd651 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "12.2 44.9 10.5 47.9 9.6 47.4 9.9 47 10.4 47.3 11.9 44.7",
    className: "colorfff svgShape"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#81d672",
    d: "M10.9,50.7c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2C8.9,53,9.8,51.4,10.9,50.7z",
    className: "color81d672 svgShape"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#494846",
    d: "M15.1,22.5c0.3-0.2,0.5-0.2,0.7-0.3c0.2,0,0.4,0,0.6,0.2l-0.5,0.8c-0.2-0.2-0.5-0.2-0.8,0 c-0.2,0.1-0.4,0.3-0.5,0.4c-0.2,0.2-0.3,0.4-0.4,0.6s-0.1,0.5-0.1,0.7c0,0.2,0,0.4,0.1,0.5c0.1,0.1,0.2,0.2,0.4,0.2 c0.2,0,0.3,0,0.5-0.2c0.3-0.2,0.6-0.5,0.8-0.9l0.5,0.2c-0.2,0.3-0.3,0.6-0.6,0.8c-0.2,0.2-0.5,0.4-0.7,0.6 c-0.3,0.2-0.6,0.3-0.9,0.3c-0.3,0-0.5-0.1-0.6-0.3c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.4,0.1-0.7,0.2-1.1c0.1-0.4,0.4-0.7,0.6-1 C14.5,23,14.8,22.7,15.1,22.5z",
    className: "color494846 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#494846",
    points: "17.6 21.1 17.6 24.1 19.2 23.2 19.2 23.9 16.9 25.2 16.9 21.6",
    className: "color494846 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#494846",
    d: "M21.4,19l1.4,2.8L22,22.3l-0.3-0.6l-1.5,0.8L20,23.4l-0.7,0.4l1.4-4.4L21.4,19z M20.5,21.7l1-0.6L21,20 L20.5,21.7",
    className: "color494846 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#494846",
    points: "23.9 17.6 23.9 21.2 23.1 21.6 23.1 18",
    className: "color494846 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#494846",
    points: "28.2 15.1 28.2 18.7 27.5 19.1 27.5 16.9 26.6 19.3 26.2 19.4 25.3 18.2 25.3 20.4 24.6 20.8 24.6 17.1 25.2 16.8 26.4 18.4 27.6 15.4",
    className: "color494846 svgShape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthclaims);
export default __webpack_public_path__ + "static/media/healthclaims.783fcd2ac4021c4c554b240b79cb58cf.svg";
export { ForwardRef as ReactComponent };